export const Drips_List = (t: any) => [
	{
		Header: t("Farm"),
		accessor: "farm",
	},
	{
		Header: t("Field"),
		accessor: "field",
	},
	{
		Header: t("Tree"),
		accessor: "Tree",
	},
	{
		Header: t("Total Drips"),
		accessor: "total_drips",
	},
	{
		Header: t("Broken Drips"),
		accessor: "broken_drips",
	},
	{
		Header: t("Drip Flow Rate"),
		accessor: "drip_flow_rate",
	},
];
